module.exports = __webpack_public_path__ + "static/img/honor-9.8d17db4.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/honor-9.png
// module id = 8eAe
// module chunks = 0